import { createVanIconComponent } from "./van"

const ArrowUp = createVanIconComponent("arrow-up")
export default ArrowUp
